import script from "./StatisticsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsPage.vue?vue&type=style&index=0&id=7e785e01&lang=less"

const __exports__ = script;

export default __exports__